import { useEffect, useState } from 'react';
import type AgendaEntryReturn from '../models/agenda-entry-return';
import { getAgendaEntriesByMonthForUser, getAgendaEntryForUser } from '../services/agenda-entry.service';
import { useKeycloak } from '../../authentication/keycloak/KeycloakProvider';

interface UserAgendaEntryState {
  readonly error?: boolean;
  readonly userAgendaEntry?: AgendaEntryReturn;
}
interface UserAgendaEntriesState {
  readonly error?: boolean;
  readonly userAgendaEntries?: AgendaEntryReturn[];
}
interface AgendaEntryProps {
  officeId: string | undefined;
  email: string;
  date: string;
}

export const useAgendaEntryForUser = ({ officeId, email, date }: AgendaEntryProps): UserAgendaEntryState => {
  const [state, setState] = useState<UserAgendaEntryState>({});
  const keycloak = useKeycloak();

  useEffect(() => {
    if (!officeId) {
      return;
    }
    const getAgendaEntry = async (): Promise<void> => {
      try {
        const userAgendaEntry = await getAgendaEntryForUser(officeId, email, date, keycloak);
        setState({ userAgendaEntry });
      } catch (error) {
        setState({ error: true });
      }
    };

    getAgendaEntry();
  }, [setState, keycloak, officeId, date, email]);

  return state;
};

export const useAgendaEntriesForUserByMonth = (officeId: string, email: string, date: Date): UserAgendaEntriesState => {
  const [state, setState] = useState<UserAgendaEntriesState>({});
  const keycloak = useKeycloak();

  useEffect(() => {
    if (!officeId) {
      return;
    }
    const getAgendaEntry = async (): Promise<void> => {
      try {
        const userAgendaEntries = await getAgendaEntriesByMonthForUser(officeId, email, date.toISOString(), keycloak);
        setState({ userAgendaEntries });
      } catch (error) {
        setState({ error: true });
      }
    };

    getAgendaEntry();
  }, [setState, keycloak, officeId, date, email]);

  return state;
};
